<script setup>
import TimelineView from '@/components/planner/TimelineView.vue'
import TimelineGanttMobile from '@/components/planner/TimelineGanttMobile.vue'
// import TimelineMobileView from '@/components/planner/TimelineMobileView.vue'

import { useDetectDevice } from '@/composables/device'

const { isMobile } = useDetectDevice()
</script>
<template>
  <!-- <timeline-mobile-view v-if="isMobile" /> -->
  <timeline-gantt-mobile v-if="isMobile" />
  <timeline-view v-else />
</template>
